import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {
  public static readonly UrlRegister = '/api/Password/register';
  public static readonly UrlActivate = '/api/Password/activate';
  public static readonly UrlSetPin = '/api/Password/setpin';
  public static readonly UrlVerifyPin = '/api/Password/verifypin';
  public static readonly UrlUnlock = '/api/Password/unlock';
  public static readonly UrlSetPassword = '/api/Password/setpassword';
  public static readonly UrlNewPassword = '/api/Password/newpassword';
  public static readonly UrlRequestResetPin = '/api/Password/requestresetpin';
  public static readonly UrlConfirmResetPin = '/api/Password/confirmresetpin';
  public static readonly URLResetPin = '/api/Password/resetpin';
  public static readonly URLValidateCredentials = '/api/Password/validatecredentials';

  public static readonly WebAppHttpHeader = 'webApp';

  public static readonly AvailableLanguages =
    [
      {
        id: 0,
        name: 'English',
        code: 'en'
      },
      {
        id: 1,
        name: 'Romanian',
        code: 'ro'
      },
      {
        id: 2,
        name: 'Deutsch',
        code: 'de'
      }
    ];
}
